import React from 'react';
import classnames from 'classnames';
import InfoBubble from '@gp/components/InfoBubble';

import type { IBaseProps } from '@home/types/common';

interface INoPermissionTextProps extends IBaseProps {
  // 是否有权限
  hasPermission: boolean;
  // 有权限时展示的内容
  text: string | React.ReactElement | null;
  // 无权限时展示的内容
  noPermissionText?: string | React.ReactElement | null;
  // 无权限时hover提示的内容
  noPermissionTips?: string | React.ReactElement | null;
}

const NoPermissionText: React.FC<INoPermissionTextProps> = (props) => {
  const { style, className, hasPermission, text, noPermissionText = '***', noPermissionTips = 'No permission' } = props;

  // 有权限时，直接返回原始展示内容
  if (hasPermission) return text;

  // 无hover提示时
  if (!noPermissionTips) return noPermissionText || '-';

  // 无权限时展示 无权限提示内容
  return (
    <InfoBubble
      style={style}
      className={classnames('dbg-no-permission-text globalpedia-modal-font14', className)}
      customBubbleContent={noPermissionTips}
      DomOrText={<span className="dbg-cursor-pointer">{noPermissionText || '-'}</span>}
    />
  );
};

export default NoPermissionText;
